import DOMPurify from "dompurify";

/**
 * Sanitizes a vendor-supplied HTML string (e.g. a Forethought article body) for safe rendering
 * via `dangerouslySetInnerHTML`. Deliberately generic — not scoped to any one component — since
 * a vendor can return HTML content in multiple contexts, not just articles.
 */
const ALLOWED_TAGS = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "p",
  "br",
  "ul",
  "ol",
  "li",
  "strong",
  "b",
  "em",
  "i",
  "a",
  "blockquote",
  "code",
  "pre",
  "span",
];
const ALLOWED_ATTR = ["href"];

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") {
    const href = node.getAttribute("href");
    if (!href || !href.startsWith("https://")) {
      node.removeAttribute("href");
    } else {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener noreferrer");
    }
  }
});

export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR });
}
